import React, {Component} from 'react';
import {ShipContext} from './context/ShipContext';
import {GlobalContext} from "./context/GlobalContext";
import Hotspot from './Hotspot';
import {capitalizeFirstLetter} from '../../utils';

const MENU_ID = "additionaApplicationAreasForOtherVesselTypesLubricant";

class HotspotStatic extends Component {
    constructor(props) {
        super(props);

        this.handleClick = this.handleClick.bind(this);
    }

    handleClick() {
        this.props.setActiveAreaId(this.props.areaId);
        this.props.setCategoriesListVisibility(true);
    }

    render() {

        let hotspotStyles = {},
            hotspotClasses = 'hotspot js-hotspot',
            shipType = capitalizeFirstLetter(this.props.ship),
            id = `${this.props.areaName}${shipType}`,
            staticMenu = id === MENU_ID;

        if (this.props.activeAreaId === this.props.areaId || staticMenu) {
            hotspotClasses += " hotspot--active";
        } else if (this.props.activeAreaId.length !== 0 && !staticMenu) {
            hotspotStyles.opacity = 0;
            hotspotStyles.visibility = 'hidden';
        }

            if(id === MENU_ID){
                hotspotClasses += ' static-menu';
            }
        return (
            <Hotspot
                hotspotClasses={hotspotClasses}
                id={id}
                style={hotspotStyles}
                onClick={this.handleClick}
                labelText={this.props.hotspotLabelText}
            />
        )
    }
}

function HotspotStaticWithContext(props) {
    return (
        <ShipContext.Consumer>
            {(shipContext) => (
                <GlobalContext.Consumer>
                    {(globalContext) => (
                        <HotspotStatic
                            setActiveAreaId={shipContext.setActiveAreaId}
                            activeAreaId={shipContext.activeAreaId}
                            ship={shipContext.shipType}
                            setCategoriesListVisibility={globalContext.setCategoriesListVisibility}
                            {...props}
                        />
                    )}
                </GlobalContext.Consumer>
            )}
        </ShipContext.Consumer>
    )
}

export default HotspotStaticWithContext;